import React, { useState } from 'react'
import ProviderWelcomeHeader from './ProviderWelcomeHeader';
import Loader from '../../../Container/Loader/Loader';

const ProviderDashboard = () => {

  return (
    <div>
    <ProviderWelcomeHeader/>
    ProviderDashboard</div>
  )
}

export default ProviderDashboard